var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"mb-5 top-row",attrs:{"align":"center"}},[_c('v-col',{staticClass:"subtitle-2",attrs:{"cols":"2","align-self":"start"}},[_vm._v("Default Technical Text")]),_c('v-col',[_c('f-textarea',{attrs:{"value":_vm.displayTechnicalText,"rows":"2"},on:{"input":_vm.setTechnicalText}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }